export default __webpack_public_path__ + "99892d2.ttf";